(function () {
  "use strict";

  var reservationKey = "ddCartReservationUntil";
  var reservationDuration = 10 * 60 * 1000;
  var timerId = null;
  var refreshId = null;

  function readReservationEnd() {
    try {
      return Number(window.sessionStorage.getItem(reservationKey)) || 0;
    } catch (error) {
      return 0;
    }
  }

  function saveReservationEnd(value) {
    try {
      window.sessionStorage.setItem(reservationKey, String(value));
    } catch (error) {}
  }

  function clearReservationEnd() {
    try {
      window.sessionStorage.removeItem(reservationKey);
    } catch (error) {}
  }

  function ensureReservationBar() {
    var drawer = document.getElementById("CartDrawer");
    if (!drawer) return null;

    var header = drawer.querySelector(".drawer__fixed-header");
    if (!header) return null;

    var existing = drawer.querySelector("[data-dd-cart-reservation]");
    if (existing) {
      if (existing.parentNode !== header) {
        header.appendChild(existing);
      }
      return existing;
    }

    var bar = document.createElement("div");
    bar.className = "dd-cart-reservation";
    bar.setAttribute("data-dd-cart-reservation", "");
    bar.setAttribute("role", "status");
    bar.hidden = true;
    bar.innerHTML = '<span class="dd-cart-reservation__dot" aria-hidden="true"></span><span class="dd-cart-reservation__label">Reserved</span><strong class="dd-cart-reservation__time" data-dd-reservation-time>10:00</strong>';
    header.appendChild(bar);

    return bar;
  }

  function formatTime(milliseconds) {
    var totalSeconds = Math.max(0, Math.ceil(milliseconds / 1000));
    var minutes = Math.floor(totalSeconds / 60);
    var seconds = totalSeconds % 60;
    return (minutes < 10 ? "0" : "") + minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
  }

  function stopTimer() {
    if (!timerId) return;
    window.clearInterval(timerId);
    timerId = null;
  }

  function updateTimer() {
    var bar = ensureReservationBar();
    if (!bar || bar.hidden) return;

    var time = bar.querySelector("[data-dd-reservation-time]");
    var remaining = readReservationEnd() - Date.now();
    if (time) time.textContent = formatTime(remaining);
    if (remaining <= 0) stopTimer();
  }

  function showReservation(hasItems, restart) {
    var bar = ensureReservationBar();
    if (!bar) return;

    if (!hasItems) {
      bar.hidden = true;
      stopTimer();
      clearReservationEnd();
      return;
    }

    var end = readReservationEnd();
    if (restart || end <= Date.now()) {
      saveReservationEnd(Date.now() + reservationDuration);
    }

    bar.hidden = false;
    stopTimer();
    updateTimer();
    timerId = window.setInterval(updateTimer, 1000);
  }

  function cartUrl() {
    if (window.theme && window.theme.routes && window.theme.routes.cart) return window.theme.routes.cart;
    return "/cart.js";
  }

  function refreshReservation(restart) {
    window.clearTimeout(refreshId);
    refreshId = window.setTimeout(function () {
      window.fetch(cartUrl(), {
        credentials: "same-origin",
        cache: "no-store",
        headers: { "X-Requested-With": "XMLHttpRequest" }
      })
        .then(function (response) {
          if (!response.ok) throw new Error("Unable to refresh cart reservation");
          return response.json();
        })
        .then(function (cart) {
          showReservation(Number(cart.item_count) > 0, restart);
        })
        .catch(function () {});
    }, 120);
  }

  function initializeConversionElements() {
    ensureReservationBar();
    refreshReservation(false);

    var products = document.querySelector("#CartDrawer [data-products]");
    if (products && products.getAttribute("data-dd-reservation-observed") !== "true") {
      products.setAttribute("data-dd-reservation-observed", "true");
      new MutationObserver(function () {
        refreshReservation(false);
      }).observe(products, { childList: true, subtree: true, characterData: true });
    }
  }

  document.addEventListener("ajaxProduct:added", function () {
    refreshReservation(true);
  });
  document.addEventListener("cart:updated", function (event) {
    var cart = event.detail && event.detail.cart;
    if (cart && typeof cart.item_count !== "undefined") {
      showReservation(Number(cart.item_count) > 0, false);
    } else {
      refreshReservation(false);
    }
  });
  document.addEventListener("cart:build", function () {
    refreshReservation(false);
  });
  document.addEventListener("drawerOpen", function () {
    refreshReservation(false);
  });
  document.addEventListener("shopify:section:load", initializeConversionElements);
  document.addEventListener("click", function (event) {
    if (!event.target.closest("#CartDrawer button, #CartDrawer a, #CartDrawer input, #CartDrawer select")) return;
    window.setTimeout(function () { refreshReservation(false); }, 450);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeConversionElements);
  } else {
    initializeConversionElements();
  }
})();
